enum ViewMode {
    BeforeInflationNominal,
    BeforeInflationReal,
    AfterInflationNominal,
    AfterInflationReal
}

export default ViewMode;
